import mainImg from '../../assets/images/main-img.jpg';
import '../../common/css/style.css';

// • Короткий слоган або девіз студії
// • Яскраве фото або відео з виступу/занять
// • Кнопки навігації до ключових розділів
// • Контактні кнопки (реєстрація, дзвінок, соцмережі)

export const MainPage = () => {
  return (
    <div id="home" className="main-style main-page">
      <div className="background-section">
        <img
          src={mainImg}
          alt="Діти та тренери хореографічної студії «Мрія» в Києві"
          className="sr-only"
        />
        <div className="hero-content">
          <span className="hero-badge">🩰 Хореографічна студія в Києві</span>
          <h1 className="site-title">Танець, який закохує в себе з першого заняття</h1>
          <p className="hero-subtitle">
            Дитяча хореографія та спортивно-бальні танці з тренерами-чемпіонами.
            Від перших несміливих кроків — до впевненого виступу на сцені 💛
          </p>
          <div className="hero-actions">
            <a href="/#contacts" className="hero-cta">
              Записатись на заняття
            </a>
            <a href="/#groups" className="hero-cta-secondary">
              Переглянути групи
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
